// extracted by mini-css-extract-plugin
export default {"snake-dot":"Game_snake-dot__k-YPb","snake-food":"Game_snake-food__ubCV2"};